import { permissionsServiceModule } from '../../../shared/app/services/permissions-service/permissions';
import { sharedRouteConfigModule } from '../../../shared/app/routes/routes.shared-config';
import { assessmentsRouteModule } from './assessments/assessments.route';
import { uiRouterModule } from '../../../shared/app/vendor/ui-router-module';
import { loggedOutRouteModule } from './logged-out/logged-out.route';

// Configure global state settings here, as well as depend on all the
// routes needed for the app to start

// The order of the routes matters, so we define the config in it's own module,
// then each module in the priority we need the routes to load
export const allRoutesModule = angular.module('Q.routes.all', [
  uiRouterModule,
  permissionsServiceModule,
  sharedRouteConfigModule,
  assessmentsRouteModule,
  loggedOutRouteModule,
]);
